/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_MessagesInputs */

const en_nav_messages = /** @type {(inputs: Nav_MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messages`)
};

const he_nav_messages = /** @type {(inputs: Nav_MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הודעות`)
};

/**
* | output |
* | --- |
* | "Messages" |
*
* @param {Nav_MessagesInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const nav_messages = /** @type {((inputs?: Nav_MessagesInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_MessagesInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_messages(inputs)
	return he_nav_messages(inputs)
});